import React, { Fragment } from 'react';

/**
 * One translated sentence with design markup around its values. `build` calls the translator with
 * `m(<span className="bx-m">{secs}</span>)` as the value of a placeholder; the sentence is then cut
 * at the marks, so the translation decides the word order.
 */
export function rich(build: (mark: (node: React.ReactNode) => string) => string): React.ReactNode {
  const nodes: React.ReactNode[] = [];
  const text = build((node) => '\uE000' + (nodes.push(node) - 1) + '\uE001');
  return text.split(/\uE000(\d+)\uE001/).map((part, i) => (i % 2 ? <Fragment key={i}>{nodes[Number(part)]}</Fragment> : part));
}

/**
 * A plural sentence with its number in the design's mono span: `#` cannot carry markup, so the digits
 * are found in the formatted text. A form with no digits (the Arabic dual) stays plain text.
 */
export function monoCount(text: string, n: number, className = 'bx-m'): React.ReactNode {
  const digits = new Intl.NumberFormat('en-US').format(n);
  const at = text.indexOf(digits);
  if (at < 0) return text;
  return [
    text.slice(0, at),
    <span key="n" className={className}>
      {digits}
    </span>,
    text.slice(at + digits.length),
  ];
}

/**
 * Marks for `fill`: pass them as the values of a message's placeholders, and the nodes that follow the
 * message land where the language placed them (S0 is the first node). In a plural sentence the number
 * goes in as well, to choose the form: `{n, plural, one {{c} account} other {{c} accounts}}`.
 */
export const S0 = '\ue000';
export const S1 = '\ue001';
export const S2 = '\ue002';
export const S3 = '\ue003';

export function fill(message: string, ...nodes: React.ReactNode[]): React.ReactNode {
  return message
    .split(/([\ue000-\ue003])/)
    .map((part, i) => (i % 2 ? <Fragment key={i}>{nodes[part.charCodeAt(0) - 0xe000]}</Fragment> : part));
}
